document.addEventListener('DOMContentLoaded', function() {

    const form = document.getElementById('nps-form-fields');
    const submitButton = document.getElementById('nps-button');
    const messageElement = document.getElementById('nps-message');

    if (!form) {
        console.error('[NPS] No se encontró el formulario');
        return;
    }

    form.addEventListener('submit', async function(e) {
        e.preventDefault();
        console.log('[NPS] Submit detectado');

        if (!submitButton) return;

        // Estado enviando
        submitButton.disabled = true;
        submitButton.textContent = 'Enviando...';

        const formData = new FormData(form);
        const data = {};

        for (let [key, value] of formData.entries()) {
            data[key] = value;
        }

        console.log('[NPS] Datos enviados:', data);

        try {
            const response = await fetch('https://referal-api.wine.com.mx/update-customer-metaobject', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data)
            });

            console.log('[NPS] Status:', response.status);

            if (response.ok) {
                // ✅ Estado enviado correctamente
                submitButton.textContent = 'Enviado';
                showMessage('¡Gracias por tu feedback! 🍷', 'success');
                form.reset();
            } else {
                throw new Error('Respuesta no OK');
            }

        } catch (error) {
            console.error('[NPS] Error:', error);

            showMessage('Hubo un problema al enviar tu respuesta.', 'error');

            // 🔁 Volver a estado normal
            submitButton.disabled = false;
            submitButton.textContent = 'Enviar';
        }
    });

    function showMessage(text, type) {
        if (!messageElement) return;

        messageElement.textContent = text;
        messageElement.className = type;
        messageElement.style.display = 'block';

        setTimeout(() => {
            messageElement.style.display = 'none';
        }, 5000);
    }
});
